import React from 'react';
import PropTypes from 'prop-types';
import { BYOButton, ContentCard, Headline3, Small } from '@cdm/quickenloans-library/lib';
import { ArrowForward } from '@mui/icons-material';
import { testAttributes } from './Constants';
import * as styles from './ResourcesTile.module.scss';

const ResourcesTile = ({
    buttonIcon=null,
    buttonAttributes={},
    buttonClassName=null,
    className=null,
    title = '',
    subtitle = '',
    blushIllustration,
    blushIllustrationAlt=null,
    url=null,
    LinkComponent='a',
    ...props
}) => 
    (
        <ContentCard className={`${styles.cardRoot} ${className}`} testId={testAttributes.CARD_ROOT}>
            <LinkComponent className={styles.wrapper} href={url} role="button" {...props}>
                <div 
                    className={`${styles.blushIllustration} blush`} 
                    data-testid={testAttributes.CARD_ILLUSTRATION}
                    data-url={blushIllustration}
                    role="img"
                    aria-label={blushIllustrationAlt}
                    style={{backgroundImage: `url('${blushIllustration}')`}} />
                <div className={`${styles.rowTwo} rowtwosignal`}>
                    <div className={`${styles.resourcesTileMobileVerticalContainer} mobiletextcontainersignal`}>
                        {title && <Headline3 className={`${styles.cardHeadline} titlesignal`} testId={testAttributes.CARD_TITLE}>{title}</Headline3>}
                        {subtitle && <Small className={`${styles.cardSubtitle} subtitlesignal`} testId={testAttributes.CARD_TITLE}>{subtitle}</Small>}
                    </div>
                    <BYOButton
                        as='span'
                        className={`${styles.button} ${buttonClassName}`}
                        color="blue"
                        testId={testAttributes.CARD_BUTTON}
                        iconLeft={ buttonIcon || <ArrowForward />}
                        iconSize='Small'
                        iconTestId={testAttributes.CARD_BUTTON_ICON}
                        // eslint-disable-next-line react/style-prop-object
                        style="clearbordered"
                        {...buttonAttributes}
                    />
                </div>
            </LinkComponent>
        </ContentCard>
    )
ResourcesTile.propTypes = {
    /** the icon for the green button */
    buttonIcon: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    /** additional attributes for the green button */
    buttonAttributes: PropTypes.object,
    /** additional className for the green button */
    buttonClassName: PropTypes.string,
    /** className for the component */
    className: PropTypes.string,
    /** Title text or JSX */
    title: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    /** Subtitle or description text or JSX */
    subtitle: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    /** URL of Blush Illustration */
    blushIllustration: PropTypes.string.isRequired,
    /** Alt text for Blush Illustration */
    blushIllustrationAlt: PropTypes.string,
    /** Clickable component to wrap all content */
    LinkComponent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.func
    ]),
    /** Hyperlink URL */
    url: PropTypes.string,
}

export default ResourcesTile;